import { makeAutoObservable } from "mobx"
import React from "react"

import { AsyncRequestService } from "src/api"
import { adminv3_AsyncRequestItemResponse } from "src/api/models/adminv3_AsyncRequestItemResponse"
import { createLoadingKeys } from "src/lib/loading"
import { reportUnhandledApiError } from "src/lib/report"

export class AsyncRequestItemDetailModalStore {
    static Context =
        React.createContext<AsyncRequestItemDetailModalStore | null>(null)
    static LoadingKeys = createLoadingKeys("init")

    asyncRequestItem: adminv3_AsyncRequestItemResponse | null = null

    constructor() {
        makeAutoObservable(this)
    }

    async init(id: number) {
        try {
            this.asyncRequestItem =
                await AsyncRequestService.getV3AdminAsyncRequestItem({ id })
        } catch (error) {
            reportUnhandledApiError(error)
        }
    }

    get isLoading() {
        return this.asyncRequestItem === null
    }
}
